import { render } from "./FrisbuySrNavigationButton.vue?vue&type=template&id=89ba0654&scoped=true"
import script from "./FrisbuySrNavigationButton.vue?vue&type=script&lang=js"
export * from "./FrisbuySrNavigationButton.vue?vue&type=script&lang=js"

import "./FrisbuySrNavigationButton.vue?vue&type=style&index=0&id=89ba0654&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ba0654"]])

export default __exports__